namespace GeniuzPOS.ReportMasterData {
    export class Report_1601Columns {
        static columnsKey = 'ReportMasterData.Report_1601';
    }
}
